import { PropType, defineComponent } from "vue";
import SdkDictionaryTableColumn from "../sdk-dictionary-table-column/sdk-dictionary-table-column.vue";
import { DictionaryTableNote, SdkDictionary } from "@/interfaces/sdk-dictionary";

export default defineComponent({
  name: "sdk-dictionary-table",
  components: {
    SdkDictionaryTableColumn,
  },
  props: {
    table: {
      type: Object as PropType<SdkDictionary>,
      required: true,
    },
    createdNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
    },
    deleteNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
    },
    viewNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
    },
  },
});
